import type { LinksFunction } from '@remix-run/cloudflare';

import latoNormal700Font2 from 'lato/font/lato-bold/lato-bold.woff';
import latoNormal700Font1 from 'lato/font/lato-bold/lato-bold.woff2';
import latoNormal500Font2 from 'lato/font/lato-medium/lato-medium.woff';
import latoNormal500Font1 from 'lato/font/lato-medium/lato-medium.woff2';
import latoNormal400Font2 from 'lato/font/lato-regular/lato-regular.woff';
import latoNormal400Font1 from 'lato/font/lato-regular/lato-regular.woff2';
import latoNormal600Font2 from 'lato/font/lato-semibold/lato-semibold.woff';
import latoNormal600Font1 from 'lato/font/lato-semibold/lato-semibold.woff2';

export const lato400Style = `
@font-face {
  font-family: Lato;
  font-style: normal;
  font-display: optional;
  font-weight: 400;
  src: url(${latoNormal400Font1}) format("woff2"), url(${latoNormal400Font2}) format("woff");
}
`;

export const lato500Style = `
@font-face {
  font-family: Lato;
  font-style: normal;
  font-display: optional;
  font-weight: 500;
  src: url(${latoNormal500Font1}) format("woff2"), url(${latoNormal500Font2}) format("woff");
}
`;

export const lato600Style = `
@font-face {
  font-family: Lato;
  font-style: normal;
  font-display: optional;
  font-weight: 600;
  src: url(${latoNormal600Font1}) format("woff2"), url(${latoNormal600Font2}) format("woff");
}
`;

export const lato700Style = `
@font-face {
  font-family: Lato;
  font-style: normal;
  font-display: optional;
  font-weight: 700;
  src: url(${latoNormal700Font1}) format("woff2"), url(${latoNormal700Font2}) format("woff");
}
`;

export const links: LinksFunction = () => {
  return [
    { href: latoNormal400Font1, mimetype: 'font/woff2' },
    { href: latoNormal400Font2, mimetype: 'font/woff' },
    { href: latoNormal500Font1, mimetype: 'font/woff2' },
    { href: latoNormal500Font2, mimetype: 'font/woff' },
    { href: latoNormal600Font1, mimetype: 'font/woff2' },
    { href: latoNormal600Font2, mimetype: 'font/woff' },
    { href: latoNormal700Font1, mimetype: 'font/woff2' },
    { href: latoNormal700Font2, mimetype: 'font/woff' },
  ].map((stack) => {
    return {
      rel: 'preload' as const,
      as: 'font' as const,
      // default priority for font's is `highest`, meaning before scripts, css, etc
      // since we're doing `font-display: optional`, deprioritize them
      fetchPriority: 'low' as const,
      href: stack.href,
      type: stack.mimetype,
      crossOrigin: 'anonymous' as const,
    };
  });
};
